//////LIBRARY//////
import React, { useEffect, useState, Fragment, useMemo } from 'react'
import { cloneDeep, isEmpty, isUndefined, map, isEqual, isNull } from 'lodash'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import styled from 'styled-components'
import moment from 'moment'
//////COMPONENTS//////
import ActionsTable from '../../components/ActionsTable/ActionsTable'
import { ScheduledPromoManagerNested, ScheduledPromoManagerStatus, ScheduledPromoManagerTransmissionStatus } from './Components'
import Table from '../../components/Table'
import { campaignPromoActionCreators, scheduledPromoManagerActionCreators, columnsActionCreators, tableActionCreators } from '../../store/actions'
import { bindActionCreators } from 'redux'
import Button from '../../components/Ui/Buttons'
import Theme from '../../theme/theme'
import Modals from '../../components/Modals'
import DropdownCheckbox from '../../components/DropdownCheckbox'
import ToggleFilters from '../../components/Ui/ToggleFilters'
import UseDatePicker from '../../hooks/UseDatePicker'
import { TextModal, DatePickerFilterLabel } from '../../theme/GlobalCss'
import UseCheckAll from '../../hooks/UseCheckAll'
import userPrivileges from '../../constants/PrivilegesList'
import PromoCampaignUpdateHandler from './PromoCampaignUpdateHandler'
import TooltipHelp from '../../components/TooltipHelp'
import urlExport from '../../constants/UrlExport'
import TableTitle from '../../components/Table/components/TableTitle'
//////ASSETS//////
import Validation from '../../assets/icones/global/check.svg'
import Cancel from '../../assets/icones/global/close-white.svg'
import Calendar from '../../assets/icones/global/calendar.svg'

//////STYLED//////
const UsersManagerWrapper = styled.div`
	position: relative;
`
const DatePickerEffectIcon = styled.div`
	border-radius: 4px;
	background-color: ${(props) => props.theme.colors.primary};
	height: 32px;
	width: 32px;
	padding: 6px;
	box-sizing: border-box;
	cursor: pointer;
	background-image: url(${Calendar});
	background-repeat: no-repeat;
	background-size: 20px 20px;
	background-position: center;
	:hover {
		background-color: ${(props) => props.theme.colors.hoverPrimary};
	}
	transition: background-color 0.1s;
`
const ButtonWrapper = styled.div`
	display: flex;
	height: 32px;
	width: 100%;
	justify-content: space-between;
`
//////STYLED//////

const SalesHistoryManager = () => {
	const {
		user,
		translations,
		scheduledPromoManager,
		scheduledPromoFilters,
		campaign,
		userKioskPerimeter,
		successCreateCampaignPromo,
		campaignPromoErrors,
		successUpdateCampaignPromo,
		currentColumn,
		currentDir,
	} = useSelector(
		(state) => ({
			translations: state.languages.translations,
			scheduledPromoManager: state.scheduledPromoManager,
			scheduledPromoFilters: state.scheduledPromoManager.header,
			campaign: state.campaignPromo.campaign,
			user: state.user,
			userKioskPerimeter: state.user.identity.kioskSelected,
			successCreateCampaignPromo: state.campaignPromo.isSuccess || false,
			campaignPromoErrors: state.campaignPromo.error?.data || [],
			successUpdateCampaignPromo: state.campaignPromo.update || false,
			currentColumn: state.columns.currentColumn,
			currentDir: state.columns.currentDir,
		}),
		shallowEqual
	)

	const actionsScheduledPromoManager = bindActionCreators(scheduledPromoManagerActionCreators, useDispatch())
	const promoCampaignActions = bindActionCreators(campaignPromoActionCreators, useDispatch())
	const actionsColumns = bindActionCreators(columnsActionCreators, useDispatch())
	const actionsTable = bindActionCreators(tableActionCreators, useDispatch())

	// Filters
	const [prevFilter, setPrevFilter] = useState({})
	const [filters, setFilters, handleCheckElements] = UseCheckAll(prevFilter)

	// Data
	const [paging, setPaging] = useState({ page: '0', size: '250', sort: 'createdDate', nameDir: 'asc' })

	// Modals
	const [row, setRow] = useState({})
	const [showModalTransmission, setShowModalTransmission] = useState(false)
	const [showModalEditCampaign, setShowModalEditCampaign] = useState(false)
	const [showModalCancelCampaign, setShowModalCancelCampaign] = useState(false)

	const [currentPerimeterKiosks, setCurrentPerimeterKiosks] = useState([])

	const [dateEffectShowModal, dateEffectOpenDateModalHandler, dateEffectRenderModal, dateEffectStateDate, setStartDate, setEndDate] = UseDatePicker(
		{
			defaultDateStart: moment().startOf('day').subtract(7, 'days').toDate(),
			defaultDateEnd: moment().hours(23).minutes(59).add(7, 'days').toDate(),
		}
	)

	const [configTransmission, setConfigTransmission] = useState({
		name: '',
		fixedColumnSelection: true,
	})

	//Columns
	const [columns, setColumns] = useState([])
	/////////////////////////////// HANDLER //////////////////////////////////////
	// dont use _ before parameter (_paging), this char avoid to set correct size paging value
	const handlePagingPromo = (paging) => {
		const pg = {
			...paging,
			...{
				sort: !isUndefined(currentColumn.value) ? currentColumn.value : 'createdDate',
				nameDir: !isUndefined(currentDir.value) ? currentDir.value : 'asc',
			},
		}
		setPaging(pg)
		actionsScheduledPromoManager.getScheduledPromo(handleFilterSend(), pg)
	}

	const handleCloseModal = () => {
		setShowModalTransmission(false)
	}

	const handleModalTramission = (dataRow) => {
		setRow({ ...dataRow })
		if (!showModalTransmission && !isNull(dataRow.id)) {
			let cfg = cloneDeep(configTransmission)
			cfg.name = `${translations['page__promotionManagement__transmission__title']} : ${dataRow.label}`
			cfg.close = true
			cfg.actions = {
				handleCloseModal: handleCloseModal,
			}
			setConfigTransmission(cfg)
			// back call
			actionsScheduledPromoManager.getTransmissionPromo(dataRow.id)
			setShowModalTransmission(true)
		} else {
			setShowModalTransmission(false)
		}
	}

	const handleModalEditCampaign = (dataRow) => {
		setRow({ ...dataRow })
		// back call
		if (!showModalEditCampaign && !isNull(dataRow.id)) {
			promoCampaignActions.getCampaignPromo(dataRow.id)
			setShowModalEditCampaign(true)
		} else {
			setShowModalEditCampaign(false)
			promoCampaignActions.resetCampaignPromo()
		}
	}

	const handleModalCancelCampaign = (dataRow) => {
		setRow({ ...dataRow })
		// back call
		if (!showModalCancelCampaign) {
			setShowModalCancelCampaign(true)
		} else {
			promoCampaignActions.cancelCampaignPromo(dataRow.id)
			setShowModalCancelCampaign(false)
		}
	}

	const handleWithTTC = () => {
		let filtersCP = cloneDeep(filters)
		filtersCP.withTTC = !filtersCP.withTTC

		const str_filters = handleFilterSend()

		// Even if we set our hook, in HandleFilterSend,
		// TTC value is not actualised,
		// So we reset value here...
		str_filters.withTTC = filtersCP.withTTC

		setFilters(filtersCP)

		actionsScheduledPromoManager.getScheduledPromo(str_filters, paging)
	}

	const handleSubmit = (force = false) => {
		if (force) {
			actionsScheduledPromoManager.getScheduledPromo(handleFilterSend(), paging)
			return
		}

		if (isEqual(filters, prevFilter)) return // guard to call if no change

		setPrevFilter(filters)

		// Force reset paging at zero, in case when filters are preventing any pagination with current size
		let pg = cloneDeep(paging)
		if (isUndefined(pg)) {
			pg = { page: '0', size: '250', sort: 'createdDate', nameDir: 'asc' }
		} else {
			pg.page = '0'
		}
		setPaging(pg)

		actionsScheduledPromoManager.getScheduledPromo(handleFilterSend(), pg)
	}

	const handleFilterSend = (withNested = false) => {
		return {
			...filters,
			withNested: withNested,
			userKioskScope: {
				kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
			},
			datesRange: {
				dateStart: dateEffectStateDate.date.startDate,
				dateEnd: dateEffectStateDate.date.endDate,
			},
		}
	}

	/////////////////////////////// CONFIG //////////////////////////////////////

	useEffect(() => {
		setColumns([
			{
				columnReferential: 'scheduledPromotion_status',
				dataHook: 'promotionStatus.translationKey',
				headerName: translations['page__promotionManagement__tableHeader_status'],
				sortable: true,
				isAuthorize: true,
				component: ScheduledPromoManagerStatus,
				sortableId: 'campaignStatus.description',
			},
			{
				columnReferential: 'scheduledPromotion_kioskTransmissionStatus',
				dataHook: 'transmitionStatus.translationKey',
				headerName: translations['page__promotionManagement__tableHeader_transmissionStatus'],
				sortable: true,
				isAuthorize: true,
				component: ScheduledPromoManagerTransmissionStatus,
				sortableId: 'transmissionStatus.description',
			},
			{
				columnReferential: 'scheduledPromotion_type',
				dataHook: 'promotionCampaignType.translationKey',
				headerName: translations['page__promotionManagement__tableHeader_type'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
				sortableId: 'promotionCampaignType.label',
			},
			{
				columnReferential: 'scheduledPromotion_creationType',
				dataHook: 'promotionType.translationKey',
				headerName: translations['page__promotionManagement__tableHeader_creationMode'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
				sortableId: 'campaignType.label',
			},
			{
				columnReferential: 'scheduledPromotion_name',
				dataHook: 'label',
				headerName: translations['page__promotionManagement__tableHeader_label'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'label',
			},
			{
				columnReferential: 'scheduledPromotion_createAt',
				dataHook: 'createdDate',
				headerName: translations['page__promotionManagement__tableHeader_createdAt'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (!isNull(props.row.createdDate) ? moment(props.row.createdDate).format('DD/MM/YYYY HH:mm') : '-'),
				sortableId: 'createdDate',
			},
			{
				columnReferential: 'scheduledPromotion_createBy',
				dataHook: 'createdBy',
				headerName: translations['page__promotionManagement__tableHeader_createdBy'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'userCreated.lastName',
			},
			{
				columnReferential: 'scheduledPromotion_startDate',
				dataHook: 'dateStart',
				headerName: translations['page__promotionManagement__tableHeader_dateStart'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (!isNull(props.row.dateStart) ? moment(props.row.dateStart).format('DD/MM/YYYY HH:mm') : '-'),
				sortableId: 'dateStart',
			},
			{
				columnReferential: 'scheduledPromotion_endDate',
				dataHook: 'endDate',
				headerName: translations['page__promotionManagement__tableHeader_dateEnd'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (!isNull(props.row.endDate) ? moment(props.row.endDate).format('DD/MM/YYYY HH:mm') : '-'),
				sortableId: 'dateEnd',
			},
			{
				columnReferential: 'scheduledPromotion_realEndDate',
				dataHook: 'realEndDate',
				headerName: translations['page__promotionManagement__tableHeader_dateRealEnd'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (!isNull(props.row.realEndDate) ? moment(props.row.realEndDate).format('DD/MM/YYYY HH:mm') : '-'),
				sortableId: 'realDateEnd',
			},
			{
				columnReferential: 'scheduledPromotion_code',
				dataHook: 'code',
				headerName: translations['page__promotionManagement__tableHeader_code'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'code',
			},
			{
				columnReferential: 'scheduledPromotion_lastTransmission',
				dataHook: 'dateLastTransmition',
				headerName: translations['page__promotionManagement__tableHeader_lastTransmission'],
				sortable: true,
				isAuthorize: true,
				component: (props) =>
					!isNull(props.row.dateLastTransmition) ? moment(props.row.dateLastTransmition).format('DD/MM/YYYY HH:mm') : '-',
				sortableId: 'lastPromotionKioskLineTransmitted.dateTransmitted',
			},
			{
				columnReferential: 'scheduledPromotion_distributor',
				dataHook: 'labelDistributor',
				headerName: translations['page__promotionManagement__tableHeader_distributor'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'distributor.company.labelToDisplay',
			},
			{
				columnReferential: 'scheduledPromotion_impactedKiosk',
				dataHook: 'kioskQuantity',
				headerName: translations['page__promotionManagement__tableHeader_kioskNumber'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'promotionKioskLines.size',
			},
			{
				columnReferential: 'scheduledPromotion_impactedItem',
				dataHook: 'itemQuantity',
				headerName: translations['page__promotionManagement__tableHeader_itemNumber'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'promotionCampaignLines.size',
			},
			{
				action: true,
				isFixed: true,
				component: ActionsTable,
				withIcons: false,
				rest: {
					tooltipPart: 'scheduledPromoManager',
					paperActionsList: [
						{
							//iconDef: checkTransmissionIcon,
							name: translations['tooltip__admin__priceManagement__priceCampaign__transmissionDetail'],
							clickAction: (row) => {
								handleModalTramission(row)
							},
							isVisible: (row) => true,
							translationKey: 'tooltip__admin__priceManagement__priceCampaign__transmissionDetail',
						},
						{
							//iconDef: editPriceCampaignIcon,
							name: translations['tooltip__admin__priceManagement__promoCampaign__updateCampaign'],
							clickAction: (row) => {
								handleModalEditCampaign(row)
							},
							isVisible: (row) => row.promotionStatus.subFlow !== '100' && row.promotionStatus.subFlow !== '999',
							translationKey: 'tooltip__admin__priceManagement__promoCampaign__updateCampaign',
						},
						{
							//icon: cancelPriceCampaignIcon,
							name: translations['tooltip__admin__priceManagement__promoCampaign__cancelCampaign'],
							clickAction: (row) => {
								handleModalCancelCampaign(row)
							},
							isVisible: (row) =>
								row.promotionStatus.subFlow !== '100' &&
								row.promotionStatus.subFlow !== '050' &&
								row.promotionStatus.subFlow !== '999',
							translationKey: 'tooltip__admin__priceManagement__promoCampaign__cancelCampaign',
						},
					],
				},
				checkRight: userPrivileges.action[2],
			},
		])
	}, [translations])

	// Used for columns displaying (redux stored)
	const tableReferential = {
		idPageTable: 6,
		labelPageTable: 'scheduledPromotion',
	}

	const columnsTransmission = [
		{
			dataHook: 'kioskName',
			headerName: translations['modal__pricesManagement__pricesCampaign_transmition_header_kioskName'],
			sortable: true,
			isAuthorize: true,
		},
		{
			dataHook: 'transmissionStatus.translationKey',
			headerName: translations['modal__pricesManagement__pricesCampaign_transmition_header_transmitionStatus'],
			sortable: true,
			isAuthorize: true,
			component: ScheduledPromoManagerTransmissionStatus,
		},
		{
			dataHook: 'transmissionDate',
			headerName: translations['modal__pricesManagement__pricesCampaign_transmition_header_date'],
			sortable: true,
			isAuthorize: true,
			component: (props) => (!isNull(props.row.transmissionDate) ? moment(props.row.transmissionDate).format('DD/MM/YYYY HH:mm') : '-'),
		},
		{
			dataHook: 'codeKiosk',
			headerName: translations['page__transactionsHistory__admin__salesTable_tableHeader_kioskCode'],
			sortable: true,
			isAuthorize: true,
		},
		{
			dataHook: 'customerCodeKiosk',
			headerName: translations['modal__pricesManagement__pricesCampaign_transmition_header_customerCodeKiosk'],
			sortable: true,
			isAuthorize: true,
		},
		{
			dataHook: 'postalCode',
			headerName: translations['modal__pricesManagement__pricesCampaign_transmition_header_postalCode'],
			sortable: true,
			isAuthorize: true,
		},
		{
			dataHook: 'city',
			headerName: translations['modal__pricesManagement__pricesCampaign_transmition_header_city'],
			sortable: true,
			isAuthorize: true,
		},
	]

	// Config
	const [configTableTitle, setConfigTableTitle] = useState({
		actions: {
			toggleLists: [
				() => (
					<ToggleFilters
						defaultChecked
						onChangeHandler={handleWithTTC}
						name="withTTC"
						labelPrev={translations['page__global__admin__header_priceSwitch_priceHT']}
						labelNext={translations['page__global__admin__header_priceSwitch_priceTTC']}
					/>
				),
			],
			dateLists: [
				() => (
					<Fragment>
						<label style={{ color: Theme.colors.table.body.text, marginRight: '10px', lineHeight: '32px' }}>
							{translations['page__pricesManagement__pricesCampaign_filters_date']} :
						</label>
						<DatePickerEffectIcon onClick={dateEffectOpenDateModalHandler} />
						<DatePickerFilterLabel>
							<span>
								{translations['page__global__admin__header_datePicker_from']}{' '}
								{isEqual(dateEffectStateDate.date.startDate, {})
									? moment(new Date()).subtract(1, 'months').format('DD/MM/YYYY HH:mm')
									: moment(dateEffectStateDate.date.startDate).format('DD/MM/YYYY HH:mm')}
							</span>
							<span>
								{translations['page__global__admin__header_datePicker_to']}{' '}
								{isEqual(dateEffectStateDate.date.endDate, {})
									? moment(new Date()).format('DD/MM/YYYY HH:mm')
									: moment(dateEffectStateDate.date.endDate).format('DD/MM/YYYY HH:mm')}
							</span>
						</DatePickerFilterLabel>
					</Fragment>
				),
			],
		},
		paging: {
			fnSendTo: (paging) => handlePagingPromo(paging),
		},
	})
	const [configTable, setConfigTable] = useState({
		nestedValues: {
			value: true,
			nestedData: 'promotionItemLines',
			nestedComponent: ScheduledPromoManagerNested,
			nestedPointer: 'id', // To retrieve index of line which is nested toggled or not => nestedPointer = nestedPointerValuePath
			nestedPointerValuePath: 'props.row.id', // To retrieve value of line which is nested toggled or not => nestedPointer = nestedPointerValuePath
			toggleAllNestedPointer: 'toggleNested', // Are we seeing nested lines or not
			nestedUnitCall: (dataRow) => actionsScheduledPromoManager.getPromoCampaignNestedLines(dataRow.id, filters.withTTC),
			nestedMassCall: () => actionsScheduledPromoManager.getScheduledPromo(handleFilterSend(true), paging, true),
		},
	})

	/////////////////////////////// USE EFFECT //////////////////////////////////////

	useEffect(() => {
		if (dateEffectStateDate.showModal) {
			actionsScheduledPromoManager.getScheduledPromo(handleFilterSend(), paging)
		}
	}, [dateEffectShowModal])

	useEffect(() => {
		const cfg = cloneDeep(configTableTitle)
		if (!isEmpty(scheduledPromoManager) && !isUndefined(scheduledPromoManager)) {
			cfg.paging = {
				totalElements: scheduledPromoManager.paging.totalElements,
				totalPages: scheduledPromoManager.paging.totalPages,
				fnSendTo: (paging) => handlePagingPromo(paging),
			}
			setConfigTableTitle(cfg)
		}
	}, [scheduledPromoManager])

	useEffect(() => {
		if (isEmpty(translations)) return
		const filters = cloneDeep(scheduledPromoFilters)
		filters.withFilters = true
		setFilters(filters)
		setPrevFilter(filters)
	}, [scheduledPromoFilters, translations])

	useEffect(() => {
		if (isEmpty(filters.filtersSelection)) return

		let cfg = cloneDeep(configTableTitle)
		cfg.name = translations['page__pricesManagement__tab__pricesPromotions']

		cfg.actions.dateLists = [
			() => (
				<Fragment>
					<label style={{ color: Theme.colors.table.body.text, marginRight: '10px', lineHeight: '32px' }}>
						{translations['page__pricesManagement__pricesCampaign_filters_date']} :
					</label>
					<DatePickerEffectIcon onClick={dateEffectOpenDateModalHandler} />
					<DatePickerFilterLabel>
						<span>
							{translations['page__global__admin__header_datePicker_from']}{' '}
							{isEqual(dateEffectStateDate.date.startDate, {})
								? moment(new Date()).subtract(1, 'months').format('DD/MM/YYYY HH:mm')
								: moment(dateEffectStateDate.date.startDate).format('DD/MM/YYYY HH:mm')}
						</span>
						<span>
							{translations['page__global__admin__header_datePicker_to']}{' '}
							{isEqual(dateEffectStateDate.date.endDate, {})
								? moment(new Date()).format('DD/MM/YYYY HH:mm')
								: moment(dateEffectStateDate.date.endDate).format('DD/MM/YYYY HH:mm')}
						</span>
					</DatePickerFilterLabel>
				</Fragment>
			),
		]

		cfg.actions.rest = [
			() => (
				<DropdownCheckbox
					title={translations['page__pricesManagement__pricesCampaign_dropDown_transmition']}
					data={filters.filtersSelection?.campaignTransmission?.filterElements || []}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'campaignTransmission'}
					toTranslate={true}
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['page__pricesManagement__pricesCampaign_dropDown_creationMode']}
					data={filters.filtersSelection?.campaignType?.filterElements || []}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'campaignType'}
					toTranslate={true}
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['page__pricesManagement__pricesCampaign_dropDown_status']}
					data={filters.filtersSelection?.campaignStatus?.filterElements || []}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'campaignStatus'}
					toTranslate={true}
				/>
			),
		]
		cfg.actions.toggleLists = [
			() => (
				<TooltipHelp content={'tooltipHelp__admin__modal__body__table__filter__vatSwitch'} childrenPos={2}>
					<ToggleFilters
						checked={filters.withTTC}
						onChangeHandler={handleWithTTC}
						size={'large'}
						name="withTTC"
						labelPrev={translations['page__global__admin__header_priceSwitch_priceHT']}
						labelNext={translations['page__global__admin__header_priceSwitch_priceTTC']}
					/>
				</TooltipHelp>
			),
		]
		cfg.paging = {
			totalElements: scheduledPromoManager.paging.totalElements,
			totalPages: scheduledPromoManager.paging.totalPages,
			fnSendTo: (paging) => handlePagingPromo(paging),
		}
		setConfigTableTitle(cfg)

		let cfg2 = cloneDeep(configTable)

		cfg2.nestedValues.nestedMassCall = () => actionsScheduledPromoManager.getScheduledPromo(handleFilterSend(true), paging, 0, true)
		cfg2.nestedValues.nestedUnitCall = (dataRow) => actionsScheduledPromoManager.getPromoCampaignNestedLines(dataRow.id, filters.withTTC)
		setConfigTable(cfg2)
	}, [translations, filters, prevFilter, dateEffectStateDate])

	useEffect(() => {
		const cfgCp = cloneDeep(configTable)
		cfgCp.export = {
			privilege: userPrivileges.export[4],
			url: urlExport[9],
			bd: {
				filtersSelection: filters.filtersSelection,
				withFilters: true,
				withTTC: filters.withTTC,
				withNested: true,
				datesRange: { dateEnd: dateEffectStateDate.date.endDate, dateStart: dateEffectStateDate.date.startDate },
				userKioskScope: {
					kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
				},
			},
		}

		cfgCp.nestedValues.nestedMassCall = () => actionsScheduledPromoManager.getScheduledPromo(handleFilterSend(true), paging, 0, true)
		cfgCp.nestedValues.nestedUnitCall = (dataRow) => actionsScheduledPromoManager.getPromoCampaignNestedLines(dataRow.id, filters.withTTC)

		setConfigTable(cfgCp)
	}, [translations, filters])

	const [swytch, setSwytch] = useState(false)

	useEffect(() => {
		if (!isUndefined(user) || !isEmpty(scheduledPromoManager.promotionNumber)) {
			setSwytch(true)
		}
	}, [user, scheduledPromoManager.promotionNumber])

	useEffect(() => {
		if (isUndefined(user) || isEmpty(translations)) return
		if (swytch) {
			let filtersCp
			if (!isEmpty(scheduledPromoManager.promotionNumber)) {
				setStartDate(moment(scheduledPromoManager.promotionNumber.promoDateStart).toDate())
				setEndDate(moment(scheduledPromoManager.promotionNumber.promoDateEnd).toDate())
				filtersCp = {
					withFilters: false,
					withNested: false, // according to refact nested we change the bool value
					userKioskScope: {
						kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
					},
					withTTC: true,
					datesRange: {
						dateStart: moment(scheduledPromoManager.promotionNumber.promoDateStart).subtract(3, 'hours'),
						dateEnd: moment(scheduledPromoManager.promotionNumber.promoDateEnd).add(3, 'hours'),
					},
				}
				actionsScheduledPromoManager.getScheduledPromo(
					filtersCp,
					{ page: '0', size: '250' },
					scheduledPromoManager.promotionNumber.promotionId
				)
				setFilters(filtersCp)
			} else {
				filtersCp = {
					withFilters: false,
					withNested: false, // according to refact nested we change the bool value
					userKioskScope: {
						kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
					},
					withTTC: true,
					datesRange: {
						// Dummy dates
						dateStart: moment().startOf('day').subtract(7, 'days').toDate(),
						dateEnd: moment().hours(23).minutes(59).add(7, 'days').toDate(),
					},
				}
				actionsScheduledPromoManager.getScheduledPromo(filtersCp)
				actionsColumns.setColumns([])

				setFilters(filtersCp)
			}
		}
	}, [swytch, translations])

	// If user is changing his perimeter, we need to make a back call
	useEffect(() => {
		if (!isEqual(userKioskPerimeter, currentPerimeterKiosks) && !isEmpty(currentPerimeterKiosks))
			actionsScheduledPromoManager.getScheduledPromo(handleFilterSend(), paging)
		setCurrentPerimeterKiosks(userKioskPerimeter)
	}, [userKioskPerimeter])

	// After updating promo
	useEffect(() => {
		if (successUpdateCampaignPromo) {
			actionsScheduledPromoManager.getScheduledPromo(handleFilterSend(), paging)
		}
	}, [successUpdateCampaignPromo])

	useEffect(() => {
		return function cleanUp() {
			actionsScheduledPromoManager.resetScheduledPromoManager()
			actionsTable.resetPaggingConfig()
		}
	}, [])

	///////////////////////////////// RENDER ///////////////////////////////////////

	const TableRender = useMemo(() => {
		return (
			<Table
				inputColumns={columns}
				inputData={scheduledPromoManager.items}
				inputConfig={configTable}
				isLoading={scheduledPromoManager.isLoading}
				currentPaging={paging}
				tableReferential={tableReferential}
				actionSort={actionsScheduledPromoManager.getScheduledPromo}
			/>
		)
	}, [scheduledPromoManager, columns, configTable, translations, paging])

	return (
		<Fragment>
			{dateEffectRenderModal()}
			{!isEqual(campaign, {}) && (
				<PromoCampaignUpdateHandler
					closeModalHandler={handleModalEditCampaign}
					showModal={showModalEditCampaign}
					data={campaign}
					withTaxes={filters.withTTC}
					campaignErrors={campaignPromoErrors}
					successCreateCampaign={successCreateCampaignPromo}
				/>
			)}
			<Modals closeModalHandler={handleModalTramission} showModal={showModalTransmission} minWidth={1200}>
				{/* <PageWrapperActions>
					<PageWrapperActionPrevPage onClick={ () => handleModalTramission() }/>
				</PageWrapperActions> */}
				{translations && showModalTransmission && (
					<>
						<TableTitle inputConfig={configTransmission} isSortColumns={false} />
						<Table
							inputColumns={columnsTransmission}
							inputData={scheduledPromoManager.transmission}
							inputConfig={configTransmission}
							currentPaging={paging}
						/>
					</>
				)}
			</Modals>
			<Modals
				closeModalHandler={() => setShowModalCancelCampaign(false)}
				showModal={showModalCancelCampaign}
				title={translations['modal__promotionManagement__cancelation_title']}
				level="error"
				icon={true}
			>
				<TextModal>
					<p>{`${translations['modal__promotionManagement__cancelation_message']} ?`}</p>
				</TextModal>
				<ButtonWrapper>
					<Button
						actionHandler={() => setShowModalCancelCampaign(false)}
						text={translations['common__text__cancel']}
						bgColor={Theme.colors.error}
						margin="true"
						img={Cancel}
					/>

					<Button
						actionHandler={() => {
							handleModalCancelCampaign(row)
						}}
						text={translations['common__text__validate']}
						bgColor={Theme.colors.validation}
						img={Validation}
					/>
				</ButtonWrapper>
			</Modals>
			<UsersManagerWrapper>
				{!isUndefined(translations) && !isUndefined(configTableTitle) && (
					<TableTitle inputConfig={configTableTitle} inputColumns={columns} tableReferential={tableReferential} />
				)}
				{!isUndefined(translations) && !isUndefined(configTable) && TableRender}
			</UsersManagerWrapper>
		</Fragment>
	)
}

SalesHistoryManager.propTypes = {}

SalesHistoryManager.defaultPropTypes = {}

export default SalesHistoryManager
